import { useState, useEffect } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { RadioGroup, RadioGroupItem } from "./ui/radio-group";
import { saveSubmission } from "../mock";

export const SignupModal = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({ company: "", name: "", email: "", phone: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.company || !form.name || !form.email) {
      toast.error("Vul alle verplichte velden in.");
      return;
    }
    saveSubmission("ws_signups", form);
    toast.success("Bedankt! Je aanmelding is ontvangen.");
    setForm({ company: "", name: "", email: "", phone: "" });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-[#f7f6ef]">
        <DialogHeader>
          <DialogTitle className="ws-modal-title">Account aanmaken</DialogTitle>
          <DialogDescription>Vul je gegevens in om een account aan te vragen bij WS Global Trading.</DialogDescription>
        </DialogHeader>
        <form className="ws-form" onSubmit={handleSubmit}>
          <div className="field">
            <Label htmlFor="su-company">Bedrijfsnaam *</Label>
            <Input id="su-company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} placeholder="Jouw bedrijfsnaam" />
          </div>
          <div className="field">
            <Label htmlFor="su-name">Volledige naam *</Label>
            <Input id="su-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Voor- en achternaam" />
          </div>
          <div className="field">
            <Label htmlFor="su-email">E-mailadres *</Label>
            <Input id="su-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="naam@bedrijf.nl" />
          </div>
          <div className="field">
            <Label htmlFor="su-phone">Telefoonnummer</Label>
            <Input id="su-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+31 6 12345678" />
          </div>
          <button type="submit" className="ws-btn ws-btn-dark" style={{ justifyContent: "center" }}>
            Verstuur
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const ContactModal = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({
    company: "",
    name: "",
    email: "",
    phone: "",
    type: "Koper",
    reason: "",
    method: "E-mail",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.company || !form.name || !form.email || !form.reason) {
      toast.error("Vul alle verplichte velden in.");
      return;
    }
    saveSubmission("ws_contacts", form);
    toast.success("Bedankt! We nemen zo snel mogelijk contact met je op.");
    setForm({ company: "", name: "", email: "", phone: "", type: "Koper", reason: "", method: "E-mail" });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg bg-[#f7f6ef] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="ws-modal-title">Neem contact met ons op</DialogTitle>
          <DialogDescription>Laat je gegevens achter en we nemen zo snel mogelijk contact met je op.</DialogDescription>
        </DialogHeader>
        <form className="ws-form" onSubmit={handleSubmit}>
          <div className="field">
            <Label htmlFor="ct-company">Bedrijfsnaam *</Label>
            <Input id="ct-company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} placeholder="Jouw bedrijfsnaam" />
          </div>
          <div className="field">
            <Label htmlFor="ct-name">Volledige naam *</Label>
            <Input id="ct-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Voor- en achternaam" />
          </div>
          <div className="field">
            <Label htmlFor="ct-email">E-mailadres *</Label>
            <Input id="ct-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="naam@bedrijf.nl" />
          </div>
          <div className="field">
            <Label htmlFor="ct-phone">Telefoonnummer</Label>
            <Input id="ct-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+31 6 12345678" />
          </div>
          <div className="field">
            <Label>Type *</Label>
            <RadioGroup
              value={form.type}
              onValueChange={(v) => setForm({ ...form, type: v })}
              className="ws-radio-row"
            >
              {["Koper", "Verkoper", "Beide"].map((opt) => (
                <div key={opt} className="radio-opt">
                  <RadioGroupItem value={opt} id={`type-${opt}`} />
                  <Label htmlFor={`type-${opt}`} style={{ marginBottom: 0 }}>{opt}</Label>
                </div>
              ))}
            </RadioGroup>
          </div>
          <div className="field">
            <Label htmlFor="ct-reason">Reden voor contact *</Label>
            <Textarea id="ct-reason" rows={3} value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} placeholder="Waar kunnen we je mee helpen?" />
          </div>
          <div className="field">
            <Label>Voorkeur contactmethode</Label>
            <RadioGroup
              value={form.method}
              onValueChange={(v) => setForm({ ...form, method: v })}
              className="ws-radio-row"
            >
              {["E-mail", "Telefoon", "WhatsApp"].map((opt) => (
                <div key={opt} className="radio-opt">
                  <RadioGroupItem value={opt} id={`method-${opt}`} />
                  <Label htmlFor={`method-${opt}`} style={{ marginBottom: 0 }}>{opt}</Label>
                </div>
              ))}
            </RadioGroup>
          </div>
          <button type="submit" className="ws-btn ws-btn-dark" style={{ justifyContent: "center" }}>
            Verstuur
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ws_cookie_choice")) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (choice) => {
    localStorage.setItem("ws_cookie_choice", choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="ws-cookie">
      <h4>Deze website gebruikt cookies</h4>
      <p>
        Wij gebruiken cookies om content te personaliseren en ons websiteverkeer te
        analyseren. Zo kunnen we onze website blijven verbeteren.
      </p>
      <div className="ws-cookie-actions">
        <button className="ws-btn ws-btn-lime" onClick={() => choose("accepted")}>
          Alles accepteren
        </button>
        <button className="ws-btn ws-cookie-decline" onClick={() => choose("declined")}>
          Alles weigeren
        </button>
      </div>
    </div>
  );
};
